import { ArrowRight, BadgeCheck, PlugZap, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./HomeAppliancesPromoBanner.css";

const HomeAppliancesPromoBanner = () => {
    const navigate = useNavigate();

    const handleExploreAppliances = () => {
        navigate("/Categories/Appliances");
    };

    return (
        <section className="appliance-promo">
            <div className="appliance-promo-container">
                <div className="appliance-promo-banner">
                    <img
                        src="/assets/images/banner/home-appliance.jpg"
                        alt="Premium home and kitchen appliances"
                    />
                    <div className="appliance-promo-overlay" />
                    <div className="appliance-promo-content">
                        <span className="appliance-promo-kicker">SALAR HOME APPLIANCES</span>
                        <h2>
                            Smarter living starts
                            <span>with the right essentials.</span>
                        </h2>
                        <p>
                            Upgrade your home with reliable appliances, smarter technology and everyday convenience designed around modern living.
                        </p>
                        <button
                            type="button"
                            className="appliance-promo-action"
                            onClick={handleExploreAppliances}
                        >
                            Explore Appliances
                            <ArrowRight size={16} strokeWidth={1.9} />
                        </button>
                    </div>
                    <div className="appliance-promo-features">
                        <div>
                            <span>
                                <PlugZap size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Smart Living</strong>
                                <small>Modern technology</small>
                            </div>
                        </div>
                        <div>
                            <span>
                                <BadgeCheck size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Trusted Quality</strong>
                                <small>Reliable appliances</small>
                            </div>
                        </div>
                        <div>
                            <span>
                                <ShieldCheck size={15} strokeWidth={1.9} />
                            </span>
                            <div>
                                <strong>Easy Installation</strong>
                                <small>Hassle-free setup</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAppliancesPromoBanner;